<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

/* Momentier — PDP main-image zoom / lightbox.
   B5 (2026-08-08): the stage image (.mom-rpdp__stage-img) was inert — no link,
   no click handler, no zoom library, default cursor — which produced the rage
   and dead clicks Clarity logged on the product image.

   Dependency-free by design: Halo's fancybox is NOT loaded on this template
   (vendor.js contains no fancybox/photoswipe/drift), and page weight is already
   the primary problem, so nothing is added to the initial payload beyond this
   file. The large image is only fetched once the shopper actually taps.

   Scope: PDP gallery only. Touches no cart, checkout, Fastrr or Shiprocket code.
   Progressive enhancement — all markup is created here at runtime, so the
   server-rendered layout is unchanged and rollback is deleting this block. */
(function () {
  'use strict';

  if (window.__momZoomInit) return;
  window.__momZoomInit = true;

  var STAGE_SEL = '.mom-rpdp__stage';
  var IMG_SEL = '.mom-rpdp__stage-img';
  var THUMB_SEL = '.mom-rpdp__thumb';

  var lb, lbImg, lbStage, btnClose, btnPrev, btnNext, counter;
  var slides = [];
  var index = 0;
  var lastFocus = null;
  var zoomed = false;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* Shopify CDN images accept a width param; ask for a larger render for the
     zoom view. Images smaller than the request are returned at their native
     size, so this never upscales or wastes bytes. */
  function bigSrc(url) {
    if (!url) return url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$11600');
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=1600';
  }

  function injectStyles() {
    if (document.getElementById('mom-zoom-css')) return;
    var s = document.createElement('style');
    s.id = 'mom-zoom-css';
    s.textContent = [
      /* --- trigger over the stage --- */
      '.mom-rpdp__stage{position:relative}',
      '.mom-rpdp__stage-img{cursor:zoom-in}',
      '.mom-zoom-hit{position:absolute;inset:0;width:100%;height:100%;margin:0;padding:0;',
      'border:0;background:transparent;cursor:zoom-in;z-index:3;-webkit-tap-highlight-color:transparent;',
      'display:block;appearance:none}',
      '.mom-zoom-hit:focus-visible{outline:2px solid currentColor;outline-offset:-4px}',
      '.mom-zoom-hit__ico{position:absolute;right:12px;bottom:12px;width:36px;height:36px;',
      'display:flex;align-items:center;justify-content:center;border-radius:50%;',
      'background:rgba(255,255,255,.86);color:#0E3D39;box-shadow:0 1px 6px rgba(0,0,0,.18);',
      'pointer-events:none;transition:transform .18s ease}',
      '.mom-zoom-hit:hover .mom-zoom-hit__ico{transform:scale(1.08)}',
      '.mom-zoom-hit__ico svg{width:18px;height:18px;display:block}',

      /* --- lightbox --- */
      '.mom-zoom[hidden]{display:none}',
      '.mom-zoom{position:fixed;inset:0;z-index:100000;display:flex;align-items:center;',
      'justify-content:center;background:rgba(12,12,12,.94)}',
      '.mom-zoom__backdrop{position:absolute;inset:0;border:0;padding:0;margin:0;background:transparent;cursor:zoom-out}',
      '.mom-zoom__stage{position:relative;margin:0;width:100%;height:100%;overflow:auto;',
      'display:flex;align-items:center;justify-content:center;touch-action:pinch-zoom;',
      '-webkit-overflow-scrolling:touch}',
      '.mom-zoom__img{max-width:100%;max-height:100%;width:auto;height:auto;display:block;',
      'margin:auto;cursor:zoom-in;user-select:none;-webkit-user-drag:none}',
      '.mom-zoom.is-zoomed .mom-zoom__stage{align-items:flex-start;justify-content:flex-start;touch-action:auto}',
      '.mom-zoom.is-zoomed .mom-zoom__img{max-width:none;max-height:none;width:230%;cursor:zoom-out}',
      '@media (min-width:750px){.mom-zoom.is-zoomed .mom-zoom__img{width:170%}}',

      '.mom-zoom__btn{position:absolute;z-index:2;width:44px;height:44px;border:0;border-radius:50%;',
      'background:rgba(255,255,255,.92);color:#141414;display:flex;align-items:center;',
      'justify-content:center;cursor:pointer;-webkit-tap-highlight-color:transparent}',
      '.mom-zoom__btn:focus-visible{outline:2px solid #fff;outline-offset:3px}',
      '.mom-zoom__btn svg{width:20px;height:20px;display:block;pointer-events:none}',
      '.mom-zoom__close{top:max(12px,env(safe-area-inset-top));right:12px}',
      '.mom-zoom__prev{left:12px;top:50%;transform:translateY(-50%)}',
      '.mom-zoom__next{right:12px;top:50%;transform:translateY(-50%)}',
      '.mom-zoom__count{position:absolute;z-index:2;left:0;right:0;',
      'bottom:max(14px,env(safe-area-inset-bottom));margin:0;text-align:center;color:#fff;',
      'font-size:13px;letter-spacing:.06em;pointer-events:none}',
      '.mom-zoom__btn[hidden],.mom-zoom__count[hidden]{display:none}',

      /* Scroll lock on <html> — deliberately NOT on <body>, whose classes the
         Halo cart drawer owns (body.cart-sidebar-show). */
      'html.mom-zoom-lock{overflow:hidden}'
    ].join('');
    document.head.appendChild(s);
  }

  var ICON_ZOOM = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5M11 8v6M8 11h6"/></svg>';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_PREV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';

  function buildLightbox() {
    lb = document.createElement('div');
    lb.className = 'mom-zoom';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product image viewer');
    lb.hidden = true;
    lb.innerHTML =
      '<button type="button" class="mom-zoom__backdrop" tabindex="-1" aria-label="Close image viewer"></button>' +
      '<figure class="mom-zoom__stage"><img class="mom-zoom__img" alt=""></figure>' +
      '<button type="button" class="mom-zoom__btn mom-zoom__prev" aria-label="Previous image">' + ICON_PREV + '</button>' +
      '<button type="button" class="mom-zoom__btn mom-zoom__next" aria-label="Next image">' + ICON_NEXT + '</button>' +
      '<button type="button" class="mom-zoom__btn mom-zoom__close" aria-label="Close image viewer">' + ICON_CLOSE + '</button>' +
      '<p class="mom-zoom__count" aria-live="polite"></p>';

    /* Appended to <body> so it escapes any transform on the section (the same
       reason the existing sticky bar re-parents itself). */
    document.body.appendChild(lb);

    lbStage = lb.querySelector('.mom-zoom__stage');
    lbImg = lb.querySelector('.mom-zoom__img');
    btnClose = lb.querySelector('.mom-zoom__close');
    btnPrev = lb.querySelector('.mom-zoom__prev');
    btnNext = lb.querySelector('.mom-zoom__next');
    counter = lb.querySelector('.mom-zoom__count');

    lb.querySelector('.mom-zoom__backdrop').addEventListener('click', close);
    btnClose.addEventListener('click', close);
    btnPrev.addEventListener('click', function () { go(-1); });
    btnNext.addEventListener('click', function () { go(1); });
    lbImg.addEventListener('click', toggleZoom);

    lb.addEventListener('keydown', onKeydown);

    /* Horizontal swipe to change image (ignored while pinched or zoomed). */
    var x0 = null, y0 = null;
    lbStage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1 || zoomed) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    lbStage.addEventListener('touchend', function (e) {
      if (x0 === null || zoomed || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      x0 = null;
    }, { passive: true });
  }

  function collectSlides(stage) {
    var out = [];
    var root = stage.closest('.mom-rpdp') || document;
    var thumbs = root.querySelectorAll(THUMB_SEL);

    if (thumbs.length) {
      Array.prototype.forEach.call(thumbs, function (t, i) {
        out.push({ src: t.getAttribute('data-full'), alt: t.getAttribute('data-alt') || '' });
        if (t.classList.contains('is-active')) index = i;
      });
    }
    if (!out.length) {
      var img = stage.querySelector(IMG_SEL);
      if (img) out.push({ src: img.getAttribute('src'), alt: img.getAttribute('alt') || '' });
      index = 0;
    }
    return out;
  }

  function paint() {
    var s = slides[index];
    if (!s) return;
    setZoom(false);
    lbImg.setAttribute('src', bigSrc(s.src));
    lbImg.setAttribute('alt', s.alt);
    var multi = slides.length > 1;
    btnPrev.hidden = !multi;
    btnNext.hidden = !multi;
    counter.hidden = !multi;
    if (multi) counter.textContent = (index + 1) + ' / ' + slides.length;
  }

  function go(step) {
    if (slides.length < 2) return;
    index = (index + step + slides.length) % slides.length;
    paint();
  }

  function setZoom(on) {
    zoomed = !!on;
    lb.classList.toggle('is-zoomed', zoomed);
    if (!zoomed) { lbStage.scrollTop = 0; lbStage.scrollLeft = 0; }
  }

  function toggleZoom(e) {
    var was = zoomed;
    setZoom(!was);
    if (!was) {
      /* Centre the pan on wherever the shopper tapped. */
      var r = lbImg.getBoundingClientRect();
      var rx = r.width ? (e.clientX - r.left) / r.width : 0.5;
      var ry = r.height ? (e.clientY - r.top) / r.height : 0.5;
      lbStage.scrollLeft = rx * (lbStage.scrollWidth - lbStage.clientWidth);
      lbStage.scrollTop = ry * (lbStage.scrollHeight - lbStage.clientHeight);
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'ArrowRight') { e.preventDefault(); go(1); return; }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); return; }
    if (e.key !== 'Tab') return;

    /* Keep focus inside the dialog. */
    var f = [btnClose, btnPrev, btnNext].filter(function (b) { return b && !b.hidden; });
    if (!f.length) return;
    var i = f.indexOf(document.activeElement);
    e.preventDefault();
    var next = e.shiftKey ? (i <= 0 ? f.length - 1 : i - 1) : (i === f.length - 1 ? 0 : i + 1);
    f[next].focus();
  }

  function open(stage) {
    lastFocus = document.activeElement;
    slides = collectSlides(stage);
    if (!slides.length) return;
    paint();
    lb.hidden = false;
    document.documentElement.classList.add('mom-zoom-lock');
    btnClose.focus();
  }

  function close() {
    lb.hidden = true;
    setZoom(false);
    document.documentElement.classList.remove('mom-zoom-lock');
    /* Drop the large image so it is not held in memory on a phone. */
    lbImg.removeAttribute('src');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  ready(function () {
    var stage = document.querySelector(STAGE_SEL);
    if (!stage || !stage.querySelector(IMG_SEL)) return;

    injectStyles();
    buildLightbox();

    /* A real <button> layered over the stage: native Enter/Space activation and
       native focus handling, with no change to the server-rendered layout and
       no change to the LCP <img> itself. */
    var hit = document.createElement('button');
    hit.type = 'button';
    hit.className = 'mom-zoom-hit';
    hit.setAttribute('aria-label', 'Zoom product image');
    hit.setAttribute('aria-haspopup', 'dialog');
    hit.innerHTML = '<span class="mom-zoom-hit__ico">' + ICON_ZOOM + '</span>';
    hit.addEventListener('click', function () { open(stage); });
    stage.appendChild(hit);
  });
})();
